import React from "react";
import cn from "classnames";
import Icon from "./Icon";

const Modal = ({ visibleModal, setVisibleModal, image }) => {
  return (
    <div className={cn("modal", { visible: visibleModal })}>
      <div className="modal__container">
        <button className="modal__close" onClick={() => setVisibleModal(false)}>
          <Icon.Close />
        </button>
        <div
          dangerouslySetInnerHTML={{ __html: image }}
          className="modal__preview"
        ></div>
        <div className="modal__inner">
          <div className="modal__title">Oh nice!</div>
          <div className="modal__content">
            <p>
              All your creations are royalty-free for personal or commercial
              projects, forever.
            </p>
            <p>
              You can help support our ongoing efforts by sharing it with your
              friends or purchasing the full library.
            </p>
            <p>
              Thank you!{" "}
              <span role="img" aria-label="Dancing">
                🕺
              </span>
            </p>
          </div>
          <div className="modal__foot">
            <a
              href={`https://twitter.com/intent/tweet/?text=Look%20what%20I%20just%20made%20with%20the%20Sapiens%20Character%20Builder%20&url=${window.location.href}&via=UI8`}
              className="modal__btn btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Icon.Twitter />
              <span className="btn__title">Share</span>
            </a>
            <a
              href="https://ui8.net/ui8/products/sapiens-character-builder"
              className="modal__link"
            >
              Purchase Full Library
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
